import React, { useState } from 'react'
import Label from "../../../components/label/Label"
import Button from "../../../components/button/Button"
import { BUTTON_TYPE } from '../../../components/button/constants'
import Heading from "../../../components/heading/Heading"
import { HEADING } from '../../../components/heading/constants/constants'
import RichGrid from '../../../components/richgrid/RichGrid'
import { useDispatch, useSelector } from 'react-redux'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import { componentKey, setIsMemberUserAccessPrePayEnabled, setRowsPerPage, setSelectedPopupPaymentOptions, setShowPopupPaymentOptions, setShowPopupPrepayRequest, setSkip } from './W8W9RequestHistorySlice'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import styles from "./W8W9RequestHistory.styles"
import { useEffect } from 'react'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import { checkW8W9Payment, getRequests, updateMemberUserAccess } from './W8W9RequestHistorySaga'
import Checkbox from '../../../components/checkbox/basecheckbox/Checkbox'
import Loadable from "../../../components/loadable/Loadable"
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP, PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../constants/constants'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import InformationPopup from '../../../components/popup/informationpopup/InformationPopup'
import PaymentDrawer from '../../components/paymentdrawer/PaymentDrawer'
import PaymentDataService from '../../../../services/PaymentDataService'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../components/paymentdrawer/constants'
import { CONTACT_FOR_PRICING, NO_PLAN_SELECTED_WARNING_TEXT, REQUEST_PURCHASE_LABEL, W8W9_REQUEST_POPUP_TEXT, W8W9_REQUEST_STATE } from './constants'
import { addNotifications } from '../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../components/toast/constants'

export default function W8W9RequestHistory() {
	useGarbageCollector(componentKey)
	const { requests, rowsPerPage, skip, totalRequests, isMemberUserAccessPrePayEnabled, loadingState, showPopupPrepayRequest, showPopupPaymentOptions, popupPaymentOptions, selectedPopupPaymentOptions } = useSelector((state) => state[componentKey])
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getRequests({ PageSize: rowsPerPage, PageNumber: (skip / rowsPerPage) + 1 }))
	}, [rowsPerPage, skip])

	const [showPaymentDrawer, setShowPaymentDrawer] = useState(false);
	const [popupText, setPopupText] = useState(W8W9_REQUEST_POPUP_TEXT);

	const W8W9_REQUEST_HISTORY_COLUMNS = [
		{
			field: "SNO#",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>SNO#</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.Id}</span>
		},
		{
			field: "userName",
			header: <Label weight={LABEL_WEIGHT[700]}>Username</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.UserName}</span>
		},
		{
			field: "planType",
			header: <Label weight={LABEL_WEIGHT[700]}>Plan Type</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PlanType}</span>
		},
		{
			field: "paidAmount",
			header: <Label weight={LABEL_WEIGHT[700]}>Paid Amount</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PaidAmount}</span>
		},
		{
			field: "transactionId",
			header: <Label weight={LABEL_WEIGHT[700]}>Transaction ID</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.TransactionId}</span>
		},
		{
			field: "total",
			header: <Label weight={LABEL_WEIGHT[700]}>Total</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.CTotal}</span>
		},
		{
			field: "used",
			header: <Label weight={LABEL_WEIGHT[700]}>Used</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.CUsed}</span>
		},
		{
			field: "available",
			header: <Label weight={LABEL_WEIGHT[700]}>Available</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.CRemain}</span>
		},
		{
			field: "date",
			header: <Label weight={LABEL_WEIGHT[700]}>Date</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.DateOfCreated}</span>
		},
	]

	const handleMemberAccessChange = (checked) => {
		dispatch(setIsMemberUserAccessPrePayEnabled(checked))
		dispatch(updateMemberUserAccess(checked))
	}

	const handlePrepayRequests = () => {
		dispatch(checkW8W9Payment())
	}

	const handlePlanChange =(selectedOption) => {
		dispatch(setSelectedPopupPaymentOptions(selectedOption))
	}

	const handleSubmit = () => {
		if(!showPopupPaymentOptions) {
			dispatch(setShowPopupPrepayRequest(false))
		}
		else if(selectedPopupPaymentOptions.id === 6) {
			setPopupText(CONTACT_FOR_PRICING)
			dispatch(setShowPopupPaymentOptions(false))
		} else {
			if(selectedPopupPaymentOptions.value !== "") {
				dispatch(setShowPopupPrepayRequest(false))
				setShowPaymentDrawer(true)
			} else {
				dispatch(addNotifications({
					heading: "Error",
					message: NO_PLAN_SELECTED_WARNING_TEXT,
					variant: TOASTER_VARIANT.WARNING
				}))
			}
		}
	}


	return (
		<>
			<div>
				<div style={styles.W8W9HeadingRow}>
					<Heading type={HEADING.H1}>W8/W9 Request History</Heading>
					<Loadable currentState={loadingState.state} loadingStates={[W8W9_REQUEST_STATE.PREPAY_LOADING]} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
						<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={ handlePrepayRequests }>Prepay Requests</Button>
					</Loadable>
				</div>
				<Loadable currentState={loadingState.state} loadingStates={[W8W9_REQUEST_STATE.ACTIONS_LOADING]} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
					<div style={styles.actionsRow}>
						<Label weight={LABEL_WEIGHT[500]} customStyles={styles.text}>Member user access prepay request</Label>
						<Checkbox checked={isMemberUserAccessPrePayEnabled} onChangeCb={(e) => handleMemberAccessChange(e.target.checked)} />
					</div>
				</Loadable>
			</div>
			<Loadable currentState={loadingState.state} loadingStates={[COMMON_LOADING_STATES.GRID_LOADING]} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
				<div style={styles.grid}>
					<RichGrid
						data={requests}
						columns={W8W9_REQUEST_HISTORY_COLUMNS}
						selectable={false}
						extractRowKey={(row) => row.Id}
						paginationProps={{
							skip: skip,
							take: rowsPerPage,
							takeOptions: ROW_SELECTION_OPTIONS,
							onChangeTakeCb: (newTake) => {
								dispatch(setRowsPerPage(newTake));
								dispatch(setSkip(0))
							},
							total: totalRequests,
							onChange: (take, t) => {
								dispatch(setRowsPerPage(take));
								dispatch(setSkip(t))
							},
						}}
					/>
				</div>
			</Loadable>
			<InformationPopup 
				isOpen={showPopupPrepayRequest}
				showClose={true}
				onCloseCb={() => dispatch(setShowPopupPrepayRequest(false))}
				confirmationButtonProps={{
					onConfirmationCb: handleSubmit,
					confirmationButtonText: showPopupPaymentOptions ? "Submit" : "Ok",
					confirmationButtonStyles: {},
					confirmationButtonType: BUTTON_TYPE.PRIMARY,
				}}
			>
				{ 
					showPopupPaymentOptions ?
					<div>
						Select a plan to proceed
						<SelectDropdown
							name="request"
							value={{ label: selectedPopupPaymentOptions?.label, value: selectedPopupPaymentOptions?.value }}
							prefixProps={{ text: "" }}
							placeHolder='Select Plan'
							onSelectCb={(name, selectedOption) => handlePlanChange(selectedOption)}
							options={popupPaymentOptions}
	
						/>
					</div>
					:
					<div>{popupText}</div>
				}
			</InformationPopup>
			{
				showPaymentDrawer &&

				<PaymentDrawer
                    isOpen={showPaymentDrawer}
                    onCloseCb={() => {
                        setShowPaymentDrawer(false)
                    }}
                    fees={{
                        OnlySeparateStatefiling: "false",
                        TotalFilingFee: selectedPopupPaymentOptions.value,
                        FilingFee: selectedPopupPaymentOptions.value,
                        USPSFee: "0",
                        TINMatchFee: "0",
                        StateFee: "0",
                        TINCount: "0",
                        StateFilingCount: "0",
                        USPSCount: "0",
                        FormCount: "0"
                    }}
                    filingFeeLabel={REQUEST_PURCHASE_LABEL}
                    paymentServiceFunctionCb={PaymentDataService.purchasePlan}
                    calculatePrepaySalesTax={true}
					paymentServiceFunctionExtraParams={{
						IsautorenewChecked: true,
						planPlanType: 3,
						IsNoticeChecked: true,
					}}
					calculateEstimatedTax={true}
					placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.W8W9_REQUEST}
                    onPaymentSuccessCb={() => {
						setShowPaymentDrawer(false)
					}}
                />
			}
		</>
	)
}